import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Readable content is the default. When the user prefers reduced motion, or
// IntersectionObserver is unavailable (older browsers, some crawlers/renderers),
// render content immediately instead of hiding it behind a scroll-triggered
// animation that may never run.
const useNoMotion = () => {
  const reduce = useReducedMotion();
  const noIO = typeof window !== "undefined" && !("IntersectionObserver" in window);
  return reduce || noIO;
};

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const plain = useNoMotion();
  if (plain) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLine = ({ children, delay = 0, as: Tag = "span" }) => {
  const plain = useNoMotion();
  if (plain) return <Tag className="block">{children}</Tag>;
  return (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => {
  const plain = useNoMotion();
  if (plain) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
